import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';

import {UntypedFormControl} from '@angular/forms';
import {Subscription, BehaviorSubject, Observable} from 'rxjs';
import {NavComponent} from '@Common/home/navbar/dynamic-core-components/component-interface.component';
import {debounceTime, distinctUntilChanged, filter, finalize, startWith, switchMap} from 'rxjs/operators';

import {ActivatedRoute, Router} from '@angular/router';
import {Page, PageService} from '../services';
import {PubSubService} from '../services/pub-sub.service';
import {tap} from 'rxjs/internal/operators/tap';

@Component({
  selector: 'p8-bdc-search-pages',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchNavComponent implements NavComponent, OnDestroy {
  @Input() data: any;
  @Input() appearance = 'fill';
  @Input() floatLabel = 'auto';

  @Output() pageSelected = new EventEmitter<Page>();

  term = new UntypedFormControl();

  pageSearch: Observable<Page[]>;

  subSearch: Subscription;

  subject: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private pubSubSvc: PubSubService,
              private pageSvc: PageService) {
    if (this.pageSvc) {
      this.pageSearch = this.term.valueChanges
        .pipe(
          debounceTime(400), distinctUntilChanged(),
          filter(searchTerm => searchTerm.length >= 3),
          tap(() => this.pubSubSvc.publish('loading', true)),
          switchMap(data => this.pageSvc
            .search(data)
            .pipe(finalize(() => this.pubSubSvc.publish('loading', false))))
        );
    }
  }

  onBlur(event) {
    console.log(event);
    console.log(event.target.style);
    // event.target.style.width = '200px';
  }

  displayPageFn = (page: Page): string => {
    return '';
  }

  goPage(page: Page) {
    this.router.navigate(['page', page.id]);
  }

  ngOnDestroy(): void {
    if (this.subSearch) {
      this.subSearch.unsubscribe();
    }
  }

}
